class NullTracer {
  trace() {}
}

export default NullTracer;
